import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

import ChipContext, { ChipVariant } from './context/ChipContext';

interface Props extends HTMLAttributes<HTMLDivElement>{
    variant?: ChipVariant;
}

function ChipContainer({ children, variant = 'fill', ...rest }:Props) {
    return (
        <ChipContext value={{ variant }}>
            <Container aria-label='chip-container'
                {...rest} >
                {children}
            </Container>
        </ChipContext>
    );
}

const Container = styled.div`
    column-gap: var(--spacing-2);
    display: flex;
`;

export default ChipContainer;
